import React from 'react';
import { Card, Grid, Typography } from '@mui/material';
import { StyledH5Heading } from '../style/StyledComponents';

const Iconstyle = {
  width: '100%',
  height: 'auto',
  maxHeight: '100%', // Ensure the image doesn't exceed the card height
  objectFit: 'cover',
  display: 'block',
};

const h5StyledHeading = {
  color: 'white',
  fontSize: '1.2rem',
  paddingLeft: '8px',
  paddingRight: '8px',
};

const descriptionStyle = {
  color: 'white',
  paddingLeft: '8px',
  paddingRight: '8px',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

function PodcastBanner({imageSource, heading, description}) {
  return (
    <Card
      sx={{
        minWidth: "119px",
        height: "150px",
        padding: "1px",
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Grid container spacing={2}>
        {/* Image on the left */}
        <Grid item xs={2}>
          <img
            src={imageSource}
            alt={"Podcast Image"}
            style={Iconstyle}
          />
        </Grid>
        {/* Description on the right */}
        <Grid item xs={10} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <StyledH5Heading sx={h5StyledHeading}>
            {heading}
          </StyledH5Heading>
          <Typography variant="body1" style={descriptionStyle}>
            {description}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

export default PodcastBanner;
